module.exports = __webpack_public_path__ + "static/img/twjd-sdo11-2.6e695c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo11-2.png
// module id = 853
// module chunks = 0